/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c029232d00f9716a65577ac8246d2f0c>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "Pen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: 'Design task' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const PenIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.22.22A.75.75 0 0 1 .936.023l9.96 2.549a2 2 0 0 1 1.478 1.608l.643 3.857a.75.75 0 0 1 .763.183l2 2a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1-.183-.763l-3.857-.643a2 2 0 0 1-1.609-1.477L.023.936A.75.75 0 0 1 .22.22m9.59 13.03.94.94 3.44-3.44-.94-.94zm1.887-4.007-2.454 2.454-4.816-.803a.5.5 0 0 1-.402-.37l-1.87-7.308 3.503 3.503a2 2 0 1 0 1.06-1.06L3.217 2.154l7.309 1.87a.5.5 0 0 1 .37.402zM8 7.5a.5.5 0 1 0-1 0 .5.5 0 0 0 1 0" clip-rule="evenodd"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
PenIcon.displayName = 'PenIcon';
var _default = exports.default = PenIcon;